export default __webpack_public_path__ + "static/media/customized.1ff9b24c.png";